export class ServicePicture{
    constructor(){}

    IsDeleted: boolean;
    ServiceID:number;
    ServicePictureID: number;
    ServicePicturePath: string;
}